var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "-2 -1 25 23.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.5312H11M8 8.53125L8 14.5312M13 19.5312H3C1.89543 19.5312 1 18.6358 1 17.5312V3.53125C1 2.42668 1.89543 1.53125 3 1.53125H8.58579C8.851 1.53125 9.10536 1.63661 9.29289 1.82414L14.7071 7.23836C14.8946 7.42589 15 7.68025 15 7.94546V17.5312C15 18.6358 14.1046 19.5312 13 19.5312Z",
    stroke: "#8C3B5E",
    strokeOpacity: 1,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDocument);
export default __webpack_public_path__ + "static/media/add-document.6710723b7065f50b3d445c285753445b.svg";
export { ForwardRef as ReactComponent };